"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiClubInvoiceRepo = createApiClubInvoiceRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const ClubInvoiceMapper_1 = require("./mappers/ClubInvoiceMapper");
const ItemList_1 = require("../../../common/models/ItemList");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
const buildApiUrl_1 = require("../../../common/api/utils/buildApiUrl");
function createApiClubInvoiceRepo() {
    return {
        getById,
        getAll,
        recalculate,
        generate,
    };
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v2/bills/${id}`),
        });
        const clubInvoice = (0, ClubInvoiceMapper_1.mapToDomainInvoice)(res);
        (0, http_helpers_1.sendSuccessStatus)();
        return clubInvoice;
    }
    catch (error) {
        console.log(error);
        (0, http_helpers_1.handleError)(error);
        return null;
    }
}
async function getAll(page = 1, pageSize = 10, filter = '', startDate = '', endDate = '', sort, invoiceType, machineIds, clubIds) {
    const sortParam = sort?.length
        ? sort.map((s) => `${s.field},${s.direction}`).join(';')
        : 'orderTime,desc';
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, buildApiUrl_1.buildApiUrl)('/v2/bills', {
                page,
                pageSize,
                filter,
                startDate,
                endDate,
                sort: sortParam,
                invoiceType,
                ...(machineIds?.length ? { machineIds } : {}),
                ...(clubIds?.length ? { clubIds } : {}),
            }),
        });
        const clubInvoices = {
            items: res.items.map(ClubInvoiceMapper_1.mapToDomainInvoiceList),
            pagination: res.pagination,
        };
        (0, http_helpers_1.sendSuccessStatus)();
        return clubInvoices;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function recalculate(invoiceId) {
    try {
        const res = await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/bills/recalculate/${invoiceId}`),
        });
        const clubInvoice = (0, ClubInvoiceMapper_1.mapToDomainInvoice)(res);
        (0, http_helpers_1.sendSuccessStatus)();
        return clubInvoice;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return null;
    }
}
async function generate(clubId, year, month) {
    try {
        const res = await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/bills/recalculate`),
            params: { clubId, year, month },
        });
        const clubInvoice = (0, ClubInvoiceMapper_1.mapToDomainInvoice)(res);
        (0, http_helpers_1.sendSuccessStatus)();
        return clubInvoice;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return null;
    }
}
